import cx from 'clsx';
import * as React from 'react';

import { isActive } from '@/components/BottomNavigation/constants';
import { BottomNavigationItem } from '@/components/BottomNavigation/types';
import { isHybrid888 } from '@/utils/isHybrid888';

import styles from './BottomNavigationSlot.module.scss';

interface BottomNavigationSlotProps {
  item: BottomNavigationItem;
}

const BottomNavigationSlot = ({ item }: BottomNavigationSlotProps) => {
  const { state, image, title, notification } = item;

  const isHybrid888App = isHybrid888();

  return (
    <div className={styles.slotContainer} data-testid="bottom-slot-container">
      <div
        className={cx(
          styles.icon,
          state === 'active' ? styles.iconActive : styles.iconInactive,
          isHybrid888App && styles.isHybrid888App
        )}
        data-testid="icon"
        style={{
          maskImage: `url(${image.source})`,
          WebkitMaskImage: `url(${image.source})`,
        }}
      ></div>
      <div className={styles.notification}>{notification}</div>
      <p
        className={cx(
          styles.title,
          isActive(state) ? styles.titleActive : styles.titleInactive,
          isHybrid888App && styles.isHybrid888App
        )}
        data-testid="title"
      >
        {title}
      </p>
    </div>
  );
};

export default BottomNavigationSlot;
